module.exports = __webpack_public_path__ + "static/media/avatar.0f28444b.svg";